export default __webpack_public_path__ + "static/media/filter.17c2655c.svg";